module.exports = __webpack_public_path__ + "img/bg-detail-card.fe20d2dd.png";